__webpack_require__.p = "https://static.moomoo.com/components/basic-video/";